
import React, {FC} from 'react';
import {Spinner} from 'react-bootstrap';

import ErrorIcon from './svgs/error.inline.svg';
import ImageDetails from './ImageDetails';
import ImageHistory from './ImageHistory';
import {useColors} from './useColors';
import {useImages} from './useImages';

import * as styles from './styles.module.scss';

type ScanImagesProps = {
	data: string[]
}

const ScanImages: FC<ScanImagesProps> = ({data: appts}) => {
	const {state} = useImages({appts});
	const colors = useColors();

	// If loading, display a spinner and status count
	if (state.loading) {
		const total = appts.length;
		return (
			<div className={styles.loading}>
				<Spinner className={styles.spinner} />
				<div className={styles.text}>
					<strong>Loading scan images</strong>
					<span>{state.images.length} / {total} complete</span>
				</div>
			</div>
		);
	}

	// TODO: add error & pending state handling
	if (state.images.length === 0) {
		return (
			<div className={styles.error}>
				<ErrorIcon />
				<div className={styles.text}>
					<strong>Error</strong>
					<span>
						Please refresh the page. If the error persists, please
						contact our customer service team.
					</span>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.section}>
			<ImageDetails images={state.images} colors={colors} />
			<ImageHistory images={state.images} colors={colors} />
		</div>
	);
};

export default ScanImages;
